import React from 'react';
import styles from './index.module.scss';

// componentes
import BotaoTabela from './../../../ComponentesCadastro/BotaoTabela';

// elemento registro
function Registro({
    dados,
    clicouAlterar,
    onClickTr
}){
    
    return <tr onClick={onClickTr}>
        {/* <td className="estreito text-center font-weight-bold">{dados.pk_cad_convenio}</td> */}
        <td>
            { dados.empresa.nome_fantasia ?
                    dados.empresa.nome_fantasia
                :
                    dados.responsavel.nome
            }
        </td>
        <td className="text-nowrap estreito">
            <BotaoTabela 
                onClick={clicouAlterar}
                icone={["fas", "sign-in-alt"]}
            >Escolher empresa!</BotaoTabela>
        </td>
    </tr>
}

export default Registro;